/** @format */
import { BASKET_MPBX_BRIDGE_FEATURE_FLAG } from '@toucan/common/services/feature-flags/constants';

import { useFeatureFlag } from '@toucan/client/global/feature-flag';

export type UseBasketFeatureFlagReturn = {
    newBasket: boolean;
};

export function useBasketFeatureFlag(): UseBasketFeatureFlagReturn {
    const flag = useFeatureFlag(BASKET_MPBX_BRIDGE_FEATURE_FLAG);

    return {
        newBasket: flag?.isEnabled ?? false,
    };
}
